<template>
  <div
          class="relative border-gray-300 rounded-md border border-solid"
          :style="graphHeight">
      <div    class="absolute w-full z-10"
              id="chartdiv"
              ref="chartdiv"
              :style="graphHeight"
      ></div>
  </div>
  <sonicu-header v-if="companiesWithoutCoordinates.length > 0">Companies without Coordinates</sonicu-header>
  <div  v-if="companiesWithoutCoordinates.length > 0"
      class="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <a v-for="key in companiesWithoutCoordinates"
         :href="'/' + key"
         :key="'nocoord' + key">
          <div
            class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400">
              <div class="flex-shrink-0">
                  <div class="h-10 w-10 rounded-full" :style="'background-color: ' + updateCircleColor(companyColorValues[key])"></div>
              </div>
              <div class="min-w-0 flex-1">
                  <span class="absolute inset-0" aria-hidden="true" />
                  <p class="text-sm font-medium text-gray-900">{{ companies[key]['name'] }}</p>
                  <p class="truncate text-sm text-gray-500">{{ companies[key]['id'] }}</p>
              </div>
          </div>
      </a>
  </div>


</template>

<script>
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import {amchartsMixin} from "@/mixins/amchartsMixin";
import am5geodata_usaLow from "@amcharts/amcharts5-geodata/usaLow";
import axios from "axios";
import SonicuHeader from "@/components/elements/SonicuHeader.vue";

export default {
    name: "EnterpriseDashboardMap",
    components: {SonicuHeader},
    mixins: [amchartsMixin],
    props: {
        companies: Object,
        companyId: String,
    },
    data() {
        return {
            // REMEMBER: AMCHARTS CANNOT BE USED WITH VUEJS REACTIVE DATA.
            companiesWithoutCoordinates: [],
            companyColorValues: {},
        }
    },
    mounted(){
        this.initializeAM5Charts();
        let root = am5.Root.new("chartdiv");

        let chart = root.container.children.push(am5map.MapChart.new(root, {
            panX: "rotateX",
            projection: am5map.geoAlbersUsa(),
        }));

        // // Create a polygon series for the map
        let polygonSeries = chart.series.push(am5map.MapPolygonSeries.new(
          root, {
              geoJSON: am5geodata_usaLow,
              fill: am5.color("#93c5fd"), //blue-300
          }
        ));

        let pointSeries = chart.series.push(
          am5map.MapPointSeries.new(root, {
              valueField: "value",
              polygonIdField: "id",
              latitudeField: "latitude",
              longitudeField: "longitude",
          })
        );

        pointSeries.bullets.push(function(root, series, dataItem) {
            // console.log("My value is {value}");
            // console.log("series", series);
            // console.log("dataItem", dataItem);
            console.log("dataContext", dataItem.dataContext);
            let container = am5.Container.new(root, {});

            let thisColor = am5.Color.fromString("#a3a3a3");

            let thisCircle = am5.Circle.new(root, {
                radius: 6,
                fill: thisColor,
                stroke: am5.color(0xFFFFFF),
                strokeWidth: 2,
                dynamic: true,
                tooltipText: "{name}",
            });

            thisCircle.events.on("click", function(ev){
                console.log("clicked on", ev.target.dataItem);
                window.location.href = "/" + ev.target.dataItem.dataContext.id;
            });

            return am5.Bullet.new(root, {
                sprite: thisCircle,
                dynamic: true,
            })
        });

        this.pointSeries = pointSeries;

        this.setGraphDataFromProps(pointSeries);
    },
    methods: {
        setGraphDataFromProps(){
            this.data = []
            // for each key in this.companies (which is an object), push the key and value into this.data
            for (const [key, value] of Object.entries(this.companies)) {
                if(this.companies[key].latitude === null || this.companies[key].longitude === null){
                    this.companiesWithoutCoordinates.push(key);
                    console.log("Skipping", key, " due to lack of lat/long");
                    axios.get(`/api-internal/${key}/dashboard/company-summary`).then(
                      companyResponse => {
                          this.companyColorValues[key] = companyResponse.data.mapStatus;
                      }
                    )
                    // TODO: We should add a notice when sites are accessible but don't have lat/long
                    continue;
                }
                this.data.push({
                    id: key,
                    latitude: this.companies[key].latitude,
                    longitude: this.companies[key].longitude,
                    value: 0,
                    name: this.companies[key].name,
                })
                axios.get(`/api-internal/${key}/dashboard/company-summary`).then(
                  companyResponse => {
                      console.log("Summary", key, companyResponse);
                      let summaryValue = companyResponse.data.mapStatus;
                      this.updateBulletColor(key, summaryValue);
                  }
                )
            }
            this.pointSeries.data.setAll(this.data);
        },
        updateBulletColor(companyId, statusInteger){
            let thisColor;
            if(statusInteger === 0){
                thisColor = am5.Color.fromString("#a3a3a3");
            } else if(statusInteger === 1){
                thisColor = am5.Color.fromString("#4ade80");
            } else if(statusInteger === 2){
                thisColor = am5.Color.fromString("#facc15");
            } else if (statusInteger === 3) {
                thisColor = am5.Color.fromString("#f87171");
            } else if (statusInteger === 4) {
                thisColor = am5.Color.fromString("#22d3ee");
            } else {
                thisColor = am5.Color.fromString("#9ca3af");
            }
            // Iterate over the array this.pointSeries.dataItems to find the one with the matching companyId
            for (var i = 0; i < this.pointSeries.dataItems.length; i++) {
                if(this.pointSeries.dataItems[i].dataContext.id === companyId){
                    console.log('Updating data item for ', companyId, 'to', statusInteger, 'with color', thisColor);
                    this.pointSeries.dataItems[i].bullets[0].get('sprite').set('fill', thisColor);
                }
            }
        },
        updateCircleColor(statusInteger){
            let thisColor;
            if(statusInteger === 0){
                thisColor = "#a3a3a3";
            } else if(statusInteger === 1){
                thisColor = "#4ade80";
            } else if(statusInteger === 2){
                thisColor = "#facc15";
            } else if (statusInteger === 3) {
                thisColor = "#f87171";
            } else if (statusInteger === 4) {
                thisColor = "#22d3ee";
            } else {
                thisColor = "#9ca3af";
            }
            return thisColor;
        },
    },
    computed: {
        graphHeight(){
            let clientHeight = document.documentElement.clientHeight;
            clientHeight = Math.max(clientHeight - 400, 450);
            return "height: " + clientHeight.toString() + "px;"
        },
    },
}
</script>

<style scoped>

</style>